import React, { useState } from 'react';
// import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";

import ChangePassword from "./ChangePassword";

import {
    Avatar, List, ListItem, ListItemAvatar, ListItemText, 
    ListItemSecondaryAction, Button
} from "@material-ui/core";
import { VpnKey } from "@material-ui/icons";



function SecuritySettings() {
    // const dispatch = useDispatch();
    const {t} = useTranslation('userManagement');

    const [passwordChangeOpen, setPasswordChangeOpen] = useState(false);

    function handlePasswordChangeOpen() {
        setPasswordChangeOpen(true);
    }

    return (<>

        <List>
            <ListItem>
                <ListItemAvatar>
                    <Avatar>
                        <VpnKey />
                    </Avatar>
                </ListItemAvatar>

                <ListItemText 
                    primary={t('common:password')}
                />

                <ListItemSecondaryAction>
                    <Button
                        color='primary'
                        variant='outlined'
                        onClick={handlePasswordChangeOpen}
                        disabled={false}
                    >
                        {t('common:change')}
                    </Button>
                </ListItemSecondaryAction>
            </ListItem>
        </List>

        <ChangePassword
            passwordChangeOpen={passwordChangeOpen}
            setPasswordChangeOpen={setPasswordChangeOpen}
        />

    </>);
}

export default SecuritySettings;